import { get, has } from 'lodash';

export default {
  methods: {
    getSchoolYear(item) {
      return get(item, 'school_year', 0);
    },

    getName(item) {
      return get(item, 'name');
    },

    getTranslatedName(item) {
      if (has(item, 'id')) {
        return this.getName(item);
      }

      return this.$t(this.getName(item));
    },
  },
};



// WEBPACK FOOTER //
// ./src/mixins/labels.js